import React from 'react'
import CardMedia from '@mui/material/CardMedia'
import {staticAssetLink} from 'helpers/url'

const coverImage = (course = 'default') => staticAssetLink('covers', `${course}.jpg`)

export default function CourseItem({course, courseName, width, height}) {
  return (
   <CardMedia
      component="img"
      image={coverImage(course)}
      width={width}
      height={height}
      onError={e => e.target.src = coverImage()}
      alt={courseName}
    />
  )
}

